import { createStore } from 'vuex'
import auth from './auth'
import notify from './notify'

export default createStore({
    state: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        auth,
        notify
    }
})
